module.exports = __webpack_public_path__ + "img/coming_soon_cl.315856ba.svg";